import { ActionEnum } from '../../action.enum';
import {
  ChecklistTemplateVersionEntryFilterResultsModel
} from '../../../models/checklist-template/checklist-template-version-entry-filter-results.model';


export namespace ChecklistTemplateSettingsQueriesAction {

  export class ToggleActions {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_SETTINGS_QUERIES_TOGGLE_ACTIONS;
    constructor (public open: boolean) {}
  }

  export class ReplaceEntryInListView {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_SETTINGS_QUERIES_TOGGLE_ACTIONS;
    constructor (public entry: ChecklistTemplateVersionEntryFilterResultsModel) {}
  }
}
